import _ from "lodash";
import {
  FILTERS,
  DEFAULT_STANDARD_FILTERS,
  ARCHIVAL_STATE_OPTIONS,
} from "./Constants";
import { CURRICULUM_TYPE_PYP } from "Constants/stringConstants";
import { getAcademicSetupType } from "Teacher/routes/LearningCourses/modules/Utils";

export const getLocalizedFilterLabels = t => ({
  grades: t("scopeAndSequence:grade_levels"),
  subjects: t("scopeAndSequence:subject_areas"),
  tags: t("common:tags"),
  archivalState: t("common:status"),
});

export const getFilterOverlayOptions = params => {
  const { t, grades, subjects, tags } = params;

  const localizedFilterLabels = getLocalizedFilterLabels(t);

  const academicSetupType = getAcademicSetupType();
  const filters = FILTERS[academicSetupType];

  return _.reduce(
    filters,
    (acc, filterKey) => {
      switch (filterKey) {
        case "grades": {
          if (!_.isEmpty(grades)) {
            acc.push({
              id: filterKey,
              label: localizedFilterLabels[filterKey],
              optionsType: "checkbox",
              filterOptions: _.map(grades, ({ id, name }) => ({
                id,
                label: name,
              })),
              includeAllOption: true,
              showSearch: true,
            });
          }

          return acc;
        }

        case "subjects": {
          if (!_.isEmpty(subjects)) {
            acc.push({
              id: filterKey,
              label: localizedFilterLabels[filterKey],
              optionsType: "checkbox",
              filterOptions: _.map(subjects, ({ id, name }) => ({
                id,
                label: name,
              })),
              includeAllOption: true,
              showSearch: true,
            });
          }

          return acc;
        }
        case "tags": {
          if (!_.isEmpty(tags)) {
            acc.push({
              id: filterKey,
              label: localizedFilterLabels[filterKey],
              optionsType: "checkbox",
              filterOptions: tags,
              includeAllOption: true,
              showSearch: true,
            });
          }

          return acc;
        }

        case "archivalState": {
          acc.push({
            id: filterKey,
            label: localizedFilterLabels[filterKey],
            optionsType: "radio",
            filterOptions: _.map(ARCHIVAL_STATE_OPTIONS, item => ({
              ...item,
              label: t(item.label),
            })),
          });

          return acc;
        }
        default:
          return acc;
      }
    },
    []
  );
};

export const getAllFiltersCount = ({ currentFilters }) => {
  return _.reduce(
    currentFilters,
    (acc, filterValue, filterKey) => {
      if (_.isEqual(filterValue, DEFAULT_STANDARD_FILTERS[filterKey])) {
        return acc;
      } else {
        return acc + 1;
      }
    },
    0
  );
};

export const getAppliedFiltersCountForFilter = ({ filterKey, filterValue }) => {
  const defaultFilterValue = DEFAULT_STANDARD_FILTERS[filterKey];

  if (_.isEqual(filterValue, defaultFilterValue)) {
    return 0;
  }

  return _.isArray(filterValue) ? _.size(filterValue) : 1;
};

export const getSideNavigationOptions = ({ standardSets }) => {
  const rootOption = {
    key: "root",
    children: _.map(standardSets, ({ id }) => id),
  };

  const options = _.map(standardSets, ({ id, title }) => ({
    key: id,
    title,
    tier: "1",
    parent: "root",
    children: [],
  }));

  return [rootOption, ...options];
};

export const getPublishedStandardsQueryVariables = params => {
  const {
    id,
    searchText = "",
    standardFilters = DEFAULT_STANDARD_FILTERS,
    standardSetIds,
    curriculumProgramType,
  } = params;

  return {
    id,
    filters: {
      searchText,
      standardSetIds,
      ...standardFilters,
    },
    isPYPCurriculum: curriculumProgramType
      ? curriculumProgramType === CURRICULUM_TYPE_PYP
      : undefined,
  };
};

export const getStandardEdges = params => {
  const { node, showCourseStandards } = params;

  if (showCourseStandards) {
    const edges = _.flatMap(
      _.get(node, "standardsWrapper.standardsEdge") ||
        _.get(node, "benchmarksWrapper.standardsEdge"),
      edge => _.map(edge.standards || [], standard => ({ node: standard }))
    );

    return edges;
  } else {
    const edges =
      _.get(node, "standardSetWrapper.publishedStandards.edges") ||
      _.get(node, "standardSetWrapper.publishedBenchmarks.edges") ||
      [];

    return edges;
  }
};
